import Vue from 'vue'
import VueRouter from 'vue-router'
import MyMap from '../views/MyMap.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'myMap',
    component: MyMap
  },
//   {
//     path: '/schoolLis',
//     name: 'schoolLis',
//     component: () => import('../views/AboutView.vue')
//  }
]

const router = new VueRouter({
  routes,
  mode:'hash',
  base:process.env.NODE_ENV === 'production' ? '/subApp/xuequ' : ''
})

export default router
